export const toSearchUrlSlug = (title) => {
  const [mainPart] = title.split(",").map((part) => part.trim());
  return mainPart.toLowerCase().replace(/\s+/g, "-");
};

export const fromSearchUrlSlug = (slug) => {
  return slug
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const formatStringForUrl = (title) => {
  if (!title) return "";
  title = title.replace(/-/g, "");
  return title.toLowerCase().replace(/\s+/g, "-");
};

const propertyMapping = {
  "Case - Appartamenti": "CaseAppartamenti",
  Uffici: "Uffici",
  "Garage - Posti Auto": "GaragePostiAuto",
  Negozi: "Negozi",
};

export const reverseFormatPropertyTitle = (formattedTitle) => {
  const originalTitle = Object.keys(propertyMapping).find(
    (key) => formatStringForUrl(key) === formattedTitle
  );
  return originalTitle || formattedTitle;
};

export const encodePropertyTypeDetails = (checkboxes) => {
  const bitmask = checkboxes.reduce((mask, checkbox, index) => {
    return checkbox.checked ? mask | (1 << index) : mask;
  }, 0);
  return bitmask.toString(36);
};

export const decodePropertyTypeDetails = (bitmaskStr, allCheckboxes) => {
  const bitmask = parseInt(bitmaskStr, 36);
  return allCheckboxes.map((checkbox, index) => ({
    ...checkbox,
    checked: (bitmask & (1 << index)) !== 0,
  }));
};

export const buildResultsPageUrl = ({
  propertyType,
  locationIds = [],
  zipCodes = [],
  sortBy,
  propertyTypeDetails,
  polygons = [],
  zoneIds = [],
  mapLocations = [],
}) => {
  // Base url
  const baseUrl = `/research`;

  // Convert zip codes into a query string
  const zipCodeQueryString =
    zipCodes.length > 0 ? zipCodes.map((zip) => `zip=${zip}`).join("&") : "";

  // Location id string
  const locationIdsQueryString =
    locationIds.length > 0
      ? locationIds.map((id) => `locationId=${id}`).join("&")
      : "";

  // Prepare property type and sort by query strings
  const propertyTypeQueryString = `propertyType=${formatStringForUrl(
    propertyType
  )}`;
  const sortByQueryString = `sortBy=${formatStringForUrl(sortBy)}`;
  const propertyTypeDetailsQueryString = `propertyTypeDetails=${encodePropertyTypeDetails(
    propertyTypeDetails
  )}`;

  // Prepare polygons string
  const polygonsQueryString =
    polygons.length > 0
      ? `polygons=${encodeURIComponent(JSON.stringify(polygons))}`
      : "";

  // Prepare zone ids string
  const zoneIdsQueryString =
    zoneIds.length > 0 ? zoneIds.map((id) => `zoneId=${id}`).join("&") : "";

  // Prepare map locations sting
  const mapLocationsQuertyString =
    mapLocations.length > 0
      ? mapLocations.map((name) => `mapLocation=${name}`).join("&")
      : "";

  // Final url
  let finalUrl = baseUrl;

  // Append zip codes, if any
  if (zipCodeQueryString) {
    finalUrl += `?${zipCodeQueryString}`;
  }

  // Append location id, if any
  if (locationIdsQueryString) {
    finalUrl += `${zipCodeQueryString ? "&" : "?"}${locationIdsQueryString}`;
  }

  // Append property type and sort by
  finalUrl += `${
    zipCodeQueryString ? "&" : "?"
  }${propertyTypeQueryString}&${sortByQueryString}&${propertyTypeDetailsQueryString}`;

  // Append zone IDs, if any
  if (zoneIdsQueryString) {
    finalUrl += `&${zoneIdsQueryString}`;
  }

  // Append polygons, if any
  if (polygonsQueryString) {
    finalUrl += `&${polygonsQueryString}`;
  }

  // Append map locations, if any
  if (mapLocationsQuertyString) {
    finalUrl += `&${mapLocationsQuertyString}`;
  }

  return finalUrl;
};
